export const ReviewsText = ({
  count,
  locale,
}: {
  count: number;
  locale?: string;
}) => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return `${count} ${locale === 'uz' ? 'ta sharh' : 'отзывов'}`;
  }

  if (lastDigit === 1) {
    return `${count} ${locale === 'uz' ? 'sharh' : 'отзыв'}`;
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return `${count} ${locale === 'uz' ? 'sharh' : 'отзыва'}`;
  }

  return `${count} ${locale === 'uz' ? 'sharhlar' : 'отзывов'}`;
};
